<template>
  <b-container fluid class="h-100 imagem-fundo">
    <b-row align-h="center" align-v="center" class="h-100 p-0">
      <b-col sm="6" lg="4" md="6" xl="3" class="bg-white rounded shadow">
        <b-row align-h="center" class="my-3">
          <b-col class="text-center">
            <h4>Ativação de usuário</h4>
            <hr />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label for="username">Usuário (login de rede)</label>
            <b-form-input
              id="username"
              v-model.trim="username"
              aria-describedby="usuario-erro"
              :state="$v.username.$error ? false : null"
              :autofocus="true"
              ref="username"
            >></b-form-input>
            <b-form-invalid-feedback id="usuario-erro">Este campo é obrigatório.</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label for="password">Senha</label>
            <b-form-input
              type="password"
              id="password"
              v-model="password"
              aria-describedby="senha-erro"
              @keyup.enter="submit"
              :state="$v.password.$error ? false : null"
            ></b-form-input>
            <b-form-invalid-feedback id="senha-erro">Este campo é obrigatório.</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label for="perfil">Tipo de perfil</label>
            <b-form-select
              v-model="perfil"
              aria-describedby="perfil-erro"
              :state="$v.perfil.$error ? false : null"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled>-- Escolha um perfil --</b-form-select-option>
              </template>
              <b-form-select-option
                v-for="perfil in perfis"
                :key="perfil.id"
                :value="perfil.id"
              >{{ perfil.descricao }}</b-form-select-option>
            </b-form-select>
            <b-form-invalid-feedback id="perfil-erro">Este campo é obrigatório.</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-button block variant="success" @click.prevent="submit" class="mt-3">Ativar usuário</b-button>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-link to="/login">Voltar para o login</b-link>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import mixinToast from "@/mixins/mixinToast.js";

export default {
  mixins: [mixinToast],
  data() {
    return {
      perfis: [],
      perfil: null,
      username: "",
      password: "",
      errorMessage: false,
      ug: null
    };
  },
  validations: {
    username: {
      required
    },
    password: {
      required
    },
    perfil: {
      required
    }
  },
  methods: {
    getPerfis() {
      this.$http.get("/perfisresidenteinterno").then(result => {
        this.perfis = result.data;
        console.log(this.perfis)
      });
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return false;
      } else {
        this.$http
          .post("/usuario/ativacao", {
            username: this.username,
            password: this.password,
            perfil: this.perfil
          })
          .then(result => {
            this.exibeToast(result.data.success, result.data.message);
          });
      }
    }
  },
  created() {
    this.ug = process.env.VUE_APP_UG;
    this.getPerfis();
  }
};
</script>

<style>
.imagem-fundo {
  background-image: url("../../assets/fundo-pagina-login.jpg");
  background-size: cover;
}
</style>
